module.exports = __webpack_public_path__ + "img/aml.39f24d1f.png";